export const cssProp = (prop: string, value: string | undefined) =>
	!!value ? `${prop}: ${value};` : "";
